const faqs = [
  {
    q: '51暗网是什么类型的网站？',
    a: '51暗网是一个聚合互联网吃瓜、黑料、爆料内容的入口导航平台，本身不生产内容，而是整理和汇总全网最热门的吃瓜资讯入口，帮助用户快速找到感兴趣的内容来源。',
  },
  {
    q: '网站的内容更新频率是怎样的？',
    a: '我们保持每日人工审核更新，平均每天新增30-50条爆料内容，热门事件会持续追踪并置顶，确保你不错过任何重要进展。',
  },
  {
    q: '如何保证爆料内容的真实性？',
    a: '所有收录的内容均来源于公开网络渠道，我们会交叉验证多方来源，标注未经证实的信息，并在内容更新时同步最新进展。建议用户理性吃瓜，自行判断。',
  },
  {
    q: '51暗网有APP吗？在哪里下载？',
    a: '有的！我们提供安卓和iOS双平台APP，具备推送通知、离线阅读和夜间模式等功能，具体下载方式请查看页面下方的APP下载区域。',
  },
  {
    q: '如果原站入口失效了怎么办？',
    a: '我们会持续监控各入口站点的可用性，一旦发现失效会第一时间更新替代入口。你也可以通过收藏本页面作为永久入口，我们会在这里发布最新可用地址。',
  },
  {
    q: '我可以投稿或提供爆料线索吗？',
    a: '欢迎投稿！请通过页面上的"联系我们"区域的联系方式发送你的爆料素材，我们会对投稿人信息严格保密，经核实后会标注来源并收录。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">常见问题</h2>
            <p className="text-sm text-foreground-500">关于51暗网，你想知道的都在这里</p>
          </div>
          <div className="max-w-3xl mx-auto space-y-3">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-background-50 rounded-lg border border-background-300/40 overflow-hidden">
                <div className="p-5">
                  <h3 className="font-heading text-sm text-foreground-900 mb-2">
                    <span className="text-primary-400 mr-2">Q{i + 1}.</span>
                    {faq.q}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed pl-6">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}